import { MoreTableCell } from "@/molecules/MoreTableCell"

import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { MoreTableCellProps, RenderItem } from "@/molecules/MoreTableCell"

export const MoreTableCellDrawer = (
  onRowClick: RowClick,
  props?: { renderItem?: RenderItem }
) =>
  function MoreTableCellDrawerComponent(
    value: Omit<MoreTableCellProps, "onRowClick">
  ) {
    return (
      <MoreTableCell
        onRowClick={onRowClick}
        renderItem={props?.renderItem}
        {...value}
      />
    )
  }
